import React from "react";

// Candles up to the decision bar only (what the learner saw when they made the call).
export const MiniChart = ({ chart, height = 140, testid = "call-card-chart" }) => {
  if (!chart?.length) return null;
  const W = 600, H = 200, pad = 6;
  const hi = Math.max(...chart.map((c) => c.h)), lo = Math.min(...chart.map((c) => c.l));
  const y = (v) => pad + (H - 2 * pad) * (1 - (v - lo) / ((hi - lo) || 1));
  const step = (W - 2 * pad) / chart.length;
  const bw = Math.max(1, step * 0.6);
  return (
    <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" style={{ width: "100%", height }} data-testid={testid}
      role="img" aria-label="Chart at decision time">
      {chart.map((c, i) => {
        const x = pad + i * step + step / 2;
        const up = c.c >= c.o;
        const col = up ? "#22C55E" : "#EF4444";
        return (
          <g key={i}>
            <line x1={x} x2={x} y1={y(c.h)} y2={y(c.l)} stroke={col} strokeWidth="1" />
            <rect x={x - bw / 2} width={bw} y={y(Math.max(c.o, c.c))} height={Math.max(1, Math.abs(y(c.o) - y(c.c)))} fill={col} />
          </g>
        );
      })}
      <line x1={W - pad} x2={W - pad} y1={0} y2={H} stroke="#F59E0B" strokeDasharray="4 4" strokeWidth="2" />
    </svg>
  );
};
